import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { ClientService } from '../../../../services/clients';
import { get } from 'http';
import { PriceListService } from '../../../../services/pricelist';


@Component({
  selector: 'app-allpricelist',
  templateUrl: './allpricelist.component.html',
  styleUrl: './allpricelist.component.scss'
})
export class AllpricelistComponent {



  @Input() isProfile: string = "";

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';

  displayedColumns: string[] = [
  
    'id',
    'university_name',
    'fees',
    'options'
  ];

  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1')
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  sarPrice: number | null = null;
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private _clientsService: ClientsService,
    private _pricelist: PriceListService,
    private _profileService: ProfileService,
    private excelExportService: ExcelExportService,
    private _userService: UserService,
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));

    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";

        this.getAllClients(10, 1);

      },
      error: (error) => console.error(error),
    });
 this._pricelist.getSARPrice().subscribe(data => {
    this.sarPrice = data.rates.EGP;
  });

  }
  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._pricelist.search(this.searchKey).subscribe({
        next: (data) => {

          this.allData = data;
          this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', 'AhmedElshahatClients', ['actions']);
  }
  delete(id: any) {
  Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._pricelist.delete(id).subscribe({
          next: (res) => {
            this.getAllClients(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
   edit(itemobj: any) {
    this.router.navigate(['/createpricelist'], { queryParams: itemobj });
  }
  getAllClients(perpage: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._pricelist.getAll().subscribe({
      next: (data) => {
        this.allData = data;
        this.stockTotal = data['last_page'];
        this.totalItems =  data['total'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }


}